export default "__VITE_ASSET__bprtF5Xd__"